import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IPermission } from '../../interfaces/DB/i-permission';
import { TokenModel } from '../../interfaces/Others/i-TokenModel';
import { IResponse } from '../../interfaces/Responses/i-responses';
import { LocalStorageService } from '../local/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  public currentUserSubject!: BehaviorSubject<any>;
  public currentUser!: Observable<any>;
  public currentUserPermissions : IPermission[]; //
  
  public currentPermsSubject!: BehaviorSubject<any>;
  public currentPerms!: Observable<any>;
  
  constructor(
    private http: HttpClient,
    private localStorage: LocalStorageService,
    public router: Router
  ) {

    this.currentUserSubject = new BehaviorSubject<any>(
      this.localStorage.GetItem('currentUserIcemInv')
    );
    this.currentUser = this.currentUserSubject.asObservable();

    this.currentPermsSubject = new BehaviorSubject<any>(
      this.localStorage.GetItem('perm')
    );
    
    this.currentPerms = this.currentPermsSubject.asObservable();


  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  SetPermissions(_perms : IPermission[]){
    this.localStorage.SetItem('perm', _perms);
    this.currentUserPermissions = _perms;
  }

  GetPermissions(){
    return this.currentUserPermissions
  }

  Login(username: string, password: string): Observable<TokenModel> {
    
    const body = new HttpParams()
      .set('grant_type', 'password')
      .set('UserName', username)
      .set('Password', password);
    return this.http.post<TokenModel>(`${environment.ApiUrl}token`, body.toString());
  }

  // Verificacion si un usuario esta logueado y el token no ha expirado aun
  public isAuthenticated(): boolean {
    // Check whether the token is expired and return
    // true or false
    const TOKEN = this.localStorage.GetItem('currentUserIcemInv');

    if (TOKEN) {
      var expires = new Date(TOKEN.ExpireTime);
      var today = new Date();
      if (today <= expires) { // posee token y el mismo aun no expira, es valido
        return true;
      }
    }
    return false;
  }

  logout() {
    this.localStorage.RemoveItem('currentUserIcemInv');
    this.currentUserSubject.next(null);
    this.router.navigate(['']);
  }

  public isAdmin(){
    return  this.currentUserValue && this.currentUserValue.Email === 'sys@clavisco.com'
  }

  public checkPerm(permToCheck: string): boolean {
    const perms = this.localStorage.GetItem('perm');
   
    if (perms && perms.length && permToCheck.length > 0) {
      return perms.some((perm: IPermission) => perm.Name === permToCheck);
    } else if (permToCheck.length == 0) {
      return true;
    }
    return false;
  }


}
